import http from './http'

const radioNewQues = {
  type: 'radio',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [
  ],
  random: false,
  maxRow: '1',
  refer: '',
  referFlag: false,
  showStat: false,
  assess: {
    options: [],
    score: 1,
    type: 0,
  },
  toPage: -1,
  toQues: 0,
  evaluateFlag: false,
  checkedLabel: '',
  options: [],
}
const uploadNewQues = {
  type: 'upload',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  file_size_limit: 5120,
  file_type_limit: ["gif", "png", "jpg", "jpeg", "bmp", "doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx", "txt", "zip", "gzip", "rar"]
}
const selectNewQues = {
  type: 'select',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  random: false,
  refer: '',
  referFlag: false,
  referIndex: 0,
  showStat: false,
  assess: {
    options: [],
    score: 1,
    type: 0,
  },
  evaluateFlag: false,
  options: [],
  checkedLabel: '',
}
const sortNewQues = {
  type: 'sort',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  random: false,
  refer: '',
  referFlag: false,
  referIndex: 0,
  options: [],
}
const descriptionNewQues = {
  type: 'description',
  title: '',
  description: '',
  required: false,
  goto: '-1',
  blankSetting: []
}
const checkboxNewQues = {
  type: 'checkbox',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [
  ],
  options: [],
  random: false,
  exclusive: false,
  maxRow: 1,
  maxLength: 0,
  refer: '',
  referFlag: false,
  showStat: false,
  assess: {
    options: [],
    score: 1,
    type: 1,
  },
  evaluateFlag: false,
}
const textareaNewQues = {
  type: 'textarea',
  title: '',
  description: '',
  required: false,
  goto: '-1',
  blankSetting: [
  ],
  rows: 1,
  maxLength: 0,
  validate: ""
}
const dateNewQues = {
  type: 'date',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
}
const regionNewQues = {
  type: 'region',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
}
const starNewQues = {
  type: 'star',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [
  ],
  starBeginNum: 1,
  starNum: 10,
  starType: 0,
  revertSort: false,
  starShowCustomStart: '',
  starShowCustomEnd: '',
  checkedStar: -1,
}
const matrixRadionNewQues = {
  type: 'matrixRadio',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  refer: '',
  referFlag: false,
  options: [],
  subTitles: [],
}
const textMultipleNewQues = {
  type: 'textMultiple',
  title: '填空题：________',
  blankSetting: [],
  description: '',
  required: true,
  goto: '-1',
  assess: {
    options: [],
    score: 1,
    type: 3
  },
}
const matrixCheckboxNewQues = {
  type: 'matrixCheckbox',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  refer: '',
  referFlag: false,
  options: [],
  subTitles: [],
}
const matrixStarNewQues = {
  type: 'matrixStar',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [
  ],
  starBeginNum: 1,
  starNum: 10,
  starType: 0,
  revertSort: false,
  starShowCustomStart: '',
  starShowCustomEnd: '',
  subTitles: [],
  refer: '',
  referFlag: false,
}
const chainedSelectsNewQues = {
  type: 'chainedSelects',
  title: '',
  description: '',
  required: true,
  goto: '-1',
  blankSetting: [],
  levels: [],
  groups: [],
}
const selectNewOpts = {
  goto: '',
  noRandom: false,
  toPage: -1,
  toQues: 0,
  display: {},
  exclusive: false,
  text: '',
}
const sortNewOpts = {
  goto: '',
  noRandom: false,
  toPage: -1,
  toQues: 0,
  display: {},
  exclusive: false,
  text: '',
}
const radioNewOpts = {
  goto: '',
  noRandom: false,
  toPage: -1,
  toQues: 0,
  text: '',
  mulKey: '',
  mulToQues: [],
  visible: [],
}
const checkboxNewOpts = {
  goto: '',
  noRandom: false,
  text: '',
  exclusive: false,
  mulKey: '',
  mulToQues: [],
  visible: [],
}
const uuidMethods = {
  uuid() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }
}
export const questionDataSetsMixin = {
  data () {
    return {
      questionDataSets: {
        radioNewQues: {...radioNewQues},
        uploadNewQues: {...uploadNewQues},
        selectNewQues: {...selectNewQues},
        starNewQues: {...starNewQues},
        sortNewQues: {...sortNewQues},
        textareaNewQues: {...textareaNewQues},
        checkboxNewQues: {...checkboxNewQues},
        matrixStarNewQues: {...matrixStarNewQues},
        matrixCheckboxNewQues: {...matrixCheckboxNewQues},
        matrixRadionNewQues: {...matrixRadionNewQues},
        chainedSelectsNewQues: {...chainedSelectsNewQues},
        textMultipleNewQues: {...textMultipleNewQues},
        descriptionNewQues: {...descriptionNewQues},
        dateNewQues: {...dateNewQues},
        regionNewQues: {...regionNewQues},
      },
      questionTypeOptSets: {
        selectNewOpts: {...selectNewOpts},
        sortNewOpts: {...sortNewOpts},
        radioNewOpts: {...radioNewOpts},
        checkboxNewOpts: {...checkboxNewOpts}
      }
    }
  },
  methods: {
    ...uuidMethods,
    removeLables (html) {
      if (!html) return ''
      return html.replace(/<\/?.+?>/g,"");
    },
  }
}
export const messageMixin = {
  methods: {
    showError (message, duration) {
      this.$message({
        showClose: true,
        message: message,
        type: 'error',
        duration: duration || 1000
      })
    },
    showSuccess (message) {
      this.$message({
        showClose: true,
        message: message,
        type: 'success',
        duration: 1000
      })
    },
    showWarn (message) {
      this.$message({
        showClose: true,
        message: message,
        type: 'warning',
        duration: 1000
      })
    }
  }
}
export const dataTypeMixin = {
  data () {
    return {
      surveyId: '',
      title: '',
      dataRange: [new Date((new Date()).getTime() - 30 * 24 * 60 * 60 * 1000), new Date()],
      dataType: 'complete',
      dataTypeOptions: [{
          label: '完整数据',
          value: 'complete'
      }, {
          label: '不完整数据',
          value: 'incomplete'
      }, {
          label: '清洗后数据',
          value: 'filtered'
      }, {
          label: '垃圾桶数据',
          value: 'deleted'
      }],
      downloadTypeOptions: [{
          label: '全部数据',
          value: '1'
      }, {
          label: '完整数据',
          value: '2'
      }, {
          label: '不完整数据',
          value: '3'
      }, {
          label: '清洗后数据',
          value: '4'
      }, {
          label: '垃圾桶数据',
          value: '5'
      }],
      downloadTypeOptions: [{
        label: '导出excel数据',
        value: '1'
      }, {
        label: '导出spss数据',
        value: '2'
      }],
      datePickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  }
}

export const htmlToTxtMixin = {
  data () {
      return {
          groupLevel: [],
          levelIndex: 0,
          ininstr: '',
          groups: [],
          surveyName: '',
          groupsTxt: ''
      }
  },
  methods: {
    ...uuidMethods,
    handleHtmlToTxt (id) {
      let _ = this
      http.get(_.interface.getSurvey, {
        surveyId: id
      }).then((response) => {
        let {code, data, message} = response
        _.survey = data
        _.surveyName = _.removeLables(data.title)
        _.groupsTxt = ''
        if (code === 1) {
          let questionTypeMap = new Map()
          questionTypeMap.set('select', '下拉题')
          questionTypeMap.set('sort', '排序题')
          questionTypeMap.set('description', '段落说明')
          questionTypeMap.set('upload', '附件题')
          questionTypeMap.set('radio', '单选题')
          questionTypeMap.set('checkbox', '多选题')
          questionTypeMap.set('textarea', '文本题')
          questionTypeMap.set('star', '打分题')
          questionTypeMap.set('matrixRadio', '矩阵单选题')
          questionTypeMap.set('matrixCheckbox', '矩阵多选题')
          questionTypeMap.set('matrixStar', '矩阵打分题')
          questionTypeMap.set('chainedSelects', '联动题')
          questionTypeMap.set('textMultiple', '填空题')
          questionTypeMap.set('date', '日期题')
          questionTypeMap.set('region', '区域题')
          _.htmlToTxt = _.removeLables(data.title) + '\n\n' + _.removeLables(data.prefix) + '\n\n'
          let pages = data.pages
          for (let i = 0; i < pages.length; i++) {
            pages[i].questions.forEach((item) => {
              let {title, description, type, options = [], subTitles = [], groups = [], levels = []} = item
              _.htmlToTxt += _.removeLables(title) + '[' + questionTypeMap.get(type) + ']'
              _.htmlToTxt += description.trim() !== '' ? '(' + description + ')\n' : '\n'
              options.forEach((value) => {
                _.htmlToTxt += value.text + (subTitles.length > 0 ?  ' ' : '\n')
              })
              if (type === 'matrixStar' || type === 'star') {
                _.htmlToTxt += (!item.revertSort) ? item.starBeginNum + '~' + (item.starBeginNum + item.starNum - 1)
                : (item.starBeginNum + item.starNum - 1) + '~' + item.starBeginNum
              }
              _.htmlToTxt += (subTitles.length > 0 || type === 'star')? '\n' : ''
              subTitles.forEach((value) => {//矩阵
                _.htmlToTxt += value.text + '\n'
              })
              if ( groups.length > 0 ) {
                _.addProfix(levels)
                //_.recursionGroups(groups)
                _.groups = _.deepClone(groups)
                _.testG(_.groups, '')
                //console.log(_.groups)
                _.recursionGroups(_.groups)
                _.htmlToTxt += _.groupsTxt
                //console.log(_.groups)
              }
              _.htmlToTxt += '\n'
            })
            if (i !== pages.length - 1) {
              _.htmlToTxt += '====分页====\n\n'
            }
          }
        } else {
          _.$message({
            type: 'error',
            message: message,
          });
        }
      }).catch((error) => {
        console.log(error)

        _.$message({
          type: 'error',
          message: '拉取信息出现异常' + error,
        });
      });
    },
    recursionGroups (groups) {
      let _ = this
      for (let item of groups) {
        if (item.str) {
          let lstIndex = item.str.lastIndexOf('+')
          _.groupsTxt += item.str.slice(Math.ceil(lstIndex/2)) + item.value + '\n'
        }
        if (item.children) {
          if (item.children.length === 0) {
          } else {
            _.recursionGroups(item.children)
          }
        }
      }
    },
    testG (groups, initStr = '') {
      for (let item of groups) {
        //console.log(initStr === '')
        if (initStr === '') {
          item.str = ''
        } else {
          item.str = initStr + '+'
        }
        if (item.children) {
          if ( item.children.length === 0) {
             } else {
               this.testG(item.children, item.str + '+')
           }
        }
      }
    },
    addProfix (levels) {
        let _ = this
        let temp = ''
        for (let i =0; i < levels.length; i++) {
            _.groupLevel.push(temp)
            temp += "+"
            _.htmlToTxt += levels[i].value + (i === levels.length - 1 ? '\n' : ' ')
        }
    },
    removeLables (html) {
      if (!html) return ''
      return html.replace(/<\/?.+?>/g,"");
    },
    tree2json(a, c) {
      var self = this;
      var e = false;
      var f = /\s+/;
      var g = /(\+*)(.*)/;
      c.groups = [];
      var h = [c.groups];
      var i = 1;
      var j = 1;
      var k;
      var l, m, n;
      var isError = false;
      for (var o = 0; o < a.length; o++) {
        l = a[o];
        n = l.lineNumber;
        m = l.lineContent;
        if (m.length === 0) {
          continue
        } else {
          if (!e) {
            c.levels = m.trim().split(f);
            if (c.levels.length) {
              k = c.levels.length;
              if (k > 10) {
                self.$message({
                  type: 'error',
                  message: '最多仅支持10级标题'
                });
                isError = true;
              }
              e = true
            }
          } else {
            var p = m.match(g);
            var q = p[1].length;
            var r = p[2];
            var s = [null, r, []];
            if (q + 1 > k) {
              self.$message({
                type: 'error',
                message: '超过最大层级(' + k + ')'
              });
              isError = true;
              continue;
            }
            if (!h[q]) {
              self.$message({
                type: 'error',
                message: '不能跨级设置选项'
              });
              isError = true;
              continue;
            }
            h[q].push(s);
            h = h.slice(0, q + 1);
            h.push(s[2]);
          }
        }
      }
      return isError;
    },
    arr2obj(arr, out) {
      arr.forEach((item, i) => {
        var text = item[1];
        var children = item[2];
        out.push({
          value: text,
          children: [],
          id: this.uuid(),
        });
        if (children.length > 0) this.arr2obj(children, out[i].children);
      });
      return out;
    },
    deepClone(original, target = Object.prototype.toString.call(original) === '[object Array]' ? [] : {}) {
      for (const prop in original) {
        if (original.hasOwnProperty(prop)) {
          if (typeof original[prop] === 'object') {
            if (Object.prototype.toString.call(original[prop]) === '[object Array]') {
              target[prop] = [];
            } else {
              target[prop] = {};
            }
            this.deepClone(original[prop], target[prop]);
          } else {
            target[prop] = original[prop];
          }
        }
      }
      return target;
    },
  }
}

export const quesMixin = {
  data() {
    return {
      optRule: {
        text: [
          {
            required: true,
            message: "请输入该选项",
            trigger: "blur"
          }
        ]
      },
      advancedSettingTitle: "展开更多设置",
      advanceSettingIcon: "header-icon el-icon-arrow-down",
      advancedSetting: 0,
    }
  },
  methods: {
    handleSettingChange(val) {
      if (val.length === 2) {
        this.advancedSettingTitle = "收起更多设置";
        this.advanceSettingIcon = "header-icon el-icon-arrow-up";
      } else {
        this.advancedSettingTitle = "展开更多设置";
        this.advanceSettingIcon = "header-icon el-icon-arrow-down";
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js